/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import config from '../../../../share/config';
import session from '../../../../share/session';
import cstmTable from '../../../../share/components/vue/PaginationTable';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import api from '@/common/api';
import utils from "../../../../share/util/utils";
import handler from '../../../../share/util/apiResultValidator';
import error from '../../../../common/nodejs/errors';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';
import ApiService from "../../../../share/util/api/service";
import { executeSyncRequest } from '../../../../share/util/api/syncRequest';
import { apiErrorDefaultAction } from "../../../../share/util/api/errorAction";

// 検索条件
const SEARCH_YEAR_RANGE = 1;
const SEARCH_MONTH_RANGE = 12;

/** 各フェーズ定義 */
const PHASE = {
  MODE: 'mode',
  WAIT: 'wait',
  EXECUTE_SELECT: 'executeSelect',
  EXECUTE_CHECK: 'executeCheck',
  EXECUTE_INPUT: 'executeInput',
  EXECUTE_SHOW: 'executeShow',
  STOP_CHECK: 'stopCheck',
  SUCCESS: 'success',
  CANCEL: 'cancel',
  REGISTERED: 'registered',
  ERROR: 'error',
  FAILED: 'failed',
  COMMON_ERROR: 'commonError',
  TERMINATE: 'terminate',
};

export default {
  name: 'requirement132',
  data() {
    return {
      phase: PHASE.MODE,
      isLoading: false,
      isDisabled: true,
      isNotSelected: true,
      modalSize: "",
      requirementId: 131,
      modeList: [],
      selectedMode: '',
      /** APIから取得した機能リストを常に保持しておく */
      originalDataList: [],
      /** 画面に表示する為の機能リスト */
      filteredDataList: [],
      /** 選択中のコード */
      selectedData: {},
      /** 保存日時（年）フィルター選択リスト */
      searchYearOptions: [''],
      /** 保存日時（月）フィルター選択リスト */
      searchMonthOptions: [''],
      /** フィルター用テキスト */
      selectedYear: '',
      selectedMonth: '',
      filterRegistrant: '',
      filterDataId: '',
      /** 削除選択されたデータのリスト */
      deletedItems: [],
      selectedItem: undefined,
      /** 入力TVV */
      type: '',
      variant: '',
      version: '',
      dataId: '',
      inputType: '',
      inputVariant: '',
      inputVersion: '',
      validateType: null,
      validateVariant: null,
      validateVersion: null,
      tvvTableItems: [],
      modal_requirement_132: false
    };
  },
  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  components: {
    'cstm-table': cstmTable,
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      userName: state => state.userProperty.userName,
      netAppId: state => state.netAppConnector.pairingAppId,
      vehicleInfo: state => state.cache.vehicleInfo,
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.REGISTERED:
        case PHASE.ERROR:
        case PHASE.FAILED:
        case PHASE.COMMON_ERROR:
        case PHASE.TERMINATE:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.MODE:
        case PHASE.WAIT:
        case PHASE.EXECUTE_SELECT:
        case PHASE.EXECUTE_CHECK:
        case PHASE.EXECUTE_INPUT:
        case PHASE.EXECUTE_SHOW:
        case PHASE.STOP_CHECK:
        case PHASE.CANCEL:
        default:
          return 'secondary';
      }
    },

    systemTableColumns() {
      return [
        { name: 'registered_at', label: 'individual.header_table_save_date' },
        { name: 'vin', label: 'message.header_measured_data_list_vin' },
        { name: 'registered_by', label: 'individual.header_table_registrants' },
        { name: 'data_id', label: 'individual.header_table_data_id' },
        { name: 'delete', label: 'individual.label_readiness_code_delete', useButton: true },
      ];
    },

    savedTvvTableColumns() {
      return [
        { name: 'tvv', label: 'individual.header_table_tvv' },
        { name: 'value', label: 'individual.header_table_saved_value' },
      ];
    },

    writeTvvTableColumns() {
      return [
        { name: 'tvv', label: 'individual.header_table_tvv' },
        { name: 'value', label: 'individual.header_table_write_value' },
      ];
    },
  },

  methods: {
    /** 初期化処理 */
    init() {
      this.modeList = [
        { value: "writeWithSavedData", text: this.$t('individual.label_write_with_saved_data_message_ws132') },
        { value: "writeWithManual", text: this.$t('individual.label_write_with_manual_message_ws132') }
      ];
      this.modal_requirement_132 = true;
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      // リソース(作業サポート_DID)のi18nキー取得
      this.i18nWsDidKey = `wsDid${this.systemId}`;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_132 = false;
    },

    ...mapActions('auth', ['logout', 'resetSession']),

    /**
     * componentのmounted時に呼び出す処理
     */
    mountedLogic() {
      // 初期の検索条件の設定（現在の年、月）
      const currentYear = new Date().getFullYear();
      // 空白(全年検索用)+今年+去年を選択できるような選択肢配列を作成
      this.searchYearOptions = [''].concat([...Array(SEARCH_YEAR_RANGE + 1)].map((_, i) => String(currentYear - i)));
      // 空白(全月検索用)+1月-12月を選択できるような選択肢配列を作成
      this.searchMonthOptions = [''].concat([...Array(SEARCH_MONTH_RANGE)].map((_, i) => String(i + 1)));
    },

    /**
     * 機能が選択されたときにOKボタンを押下できるようにする
     */
    handleSelected() {
      this.isNotSelected = false;
    },

    /**
     * テーブル行押下
     */
    clickRow: function (selected) {
      this.selectedData = selected;
      this.setHighLight();
    },

    clickConfirm() {
      this.phase = PHASE.WAIT;
    },

    clickCancel() {
      this.modalSize = '';
      this.phase = PHASE.CANCEL;
    },

    clickInput() {
      this.modalSize = '';
      this.inputType = this.type;
      this.inputVariant = this.variant;
      this.inputVersion = this.version;
      // 入力画面を表示する前にバリデーションを初期化する。
      this.validateType = null;
      this.validateVariant = null;
      this.validateVersion = null;
      this.phase = PHASE.EXECUTE_INPUT;
    },

    /** TVV入力時の形式チェック */
    checkValidate(str) {
      let result = null;
      if (str.length > 20) {
        result = { invalid: true, msg: this.$t(`message.alert_validate_max_length`, ['20']) };
      }
      else if (!str.match(/^[\x20-\x7e]*$/)) {
        result = { invalid: true, msg: this.$t(`message.alert_validate_invalid_pattern`) };
      }
      return result;
    },

    confirmInput() {
      this.validateType = this.checkValidate(this.inputType);
      this.validateVariant = this.checkValidate(this.inputVariant);
      this.validateVersion = this.checkValidate(this.inputVersion);

      if (!this.validateType && !this.validateVariant && !this.validateVersion) {
        this.type = this.inputType;
        this.variant = this.inputVariant;
        this.version = this.inputVersion;
        this.isDisabled = false;
        this.modalSize = 'lg';
        this.phase = PHASE.EXECUTE_SHOW;
      } else {
        return;
      }
    },

    deleteInput() {
      this.modalSize = 'lg';
      this.phase = PHASE.EXECUTE_SHOW;
    },

    checkSelectedData() {
      this.modalSize = '';
      if (Object.keys(this.selectedData).length !== 0) {
        this.phase = PHASE.EXECUTE_CHECK;
        // 取得データを表示する表を作成
        this.tvvData = this.selectedData.readout_data;
        // 表生成
        this.$nextTick(() => {
          this.createTvvTableItems();
        });
      } else {
        this.phase = PHASE.FAILED;
      }
    },

    /** tvvデータを表示用配列に格納 */
    createTvvTableItems() {
      this.tvvTableItems = [];
      this.tvvData.forEach(item => {
        this.tvvTableItems.push({
          tvv: this.$t(`${this.i18nWsDidKey}.${item.did}`),
          value: item.data_record,
        });
      });
    },

    /** ws131で保存したデータを表示用配列に格納 */
    createSystemTableItems(readDataList) {
      this.originalDataList = readDataList.map(readData => {
        return {
          registered_at: utils.timeConverter(readData.data_id), // data_id(UNIXTIME)をYYYY/MM/DD HH:mm:ss形式に変換
          vin: readData.vin,
          registered_by: readData.registered_by,
          data_id: readData.data_id,
          buttonVisible: true,
          readout_data: readData.readout_data
        };
      });
    },

    /**
     * 選択しているデータのハイライト設定
     */
    setHighLight() {
      this.filteredDataList.forEach(item => {
        if (item === this.selectedData) {
          item.fieldSpec = {};
          item.fieldSpec.registered_at = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.vin = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.registered_by = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.data_id = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.delete = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.locale_key = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
          }
        }
      });
    },

    /**
     * 選択状態を解除し、フィルターの文字列に応じてリストをフィルターする
     */
    async searchFilter() {
      this.selectedData = {};
      this.setHighLight();
      // カスタムテーブルの描画の為sleep処理を実施
      await utils.sleep(1000);
      this.filteredDataList = this.originalDataList.filter(item => {
        // 翻訳後の名称を大文字・小文字区別なくフィルターする
        // 削除対象は表示しない
        const yearFilter = this.selectedYear.toLowerCase();
        const monthFilter = this.selectedMonth.toLowerCase();
        const itemYear = new Date(item.data_id).getFullYear().toString();
        const itemMonth = new Date(item.data_id).getMonth() + 1;

        return (
          (yearFilter === "" || itemYear.includes(yearFilter)) &&
          (monthFilter === "" || itemMonth === Number(monthFilter)) &&
          item.registered_by.toLowerCase().includes(this.filterRegistrant.toLowerCase()) &&
          item.data_id.toString().includes(this.filterDataId) &&
          !this.deletedItems.includes(item.data_id)
        );
      });
    },

    /**
     * 行選択削除
     */
    async deleteRow(selected) {
      try {
        this.isLoading = true;
        this.selectedItem = selected;
        this.deletedItems.push(this.selectedItem.data_id);
        // カスタムテーブルの描画の為sleep処理を実施
        await utils.sleep(1000);
        // 見た目上、選択行を削除
        this.filteredDataList = this.filteredDataList.filter(item => !this.deletedItems.includes(item.data_id));
        // Tvvデータ削除処理
        await this.deleteTvvData(this.selectedItem.data_id);
        // フィルターを初期化
        this.filterRegistrant = '';
        this.filterDataId = '';
      } finally {
        this.isLoading = false;
      }
    },

    /** Tvvデータ削除処理 */
    async deleteTvvData(dataId) {
      try {
        this.isLoading = true;
        //バックエンドAPI POST
        const endPoint = '/readData/requirements/' + this.requirementId + '/netApps/' + this.netAppId + '/' + dataId;
        const response = await api.deleteCall(ApiService.WSP, endPoint);
        // APIレスポンスの検証
        handler.validate(handler.validateTypes.all, response, this, null, () => { // 処理が成功したときのコールバック処理は特になし
        }, (result) => {
          // 処理が失敗したときのコールバック処理
          // セッションが不正・ネットワークエラーならログアウト処理を行う
          if (result.causeType === handler.causeTypes.networkError ||
            result.causeType === handler.causeTypes.invalidSessionToken) {
            alert.showWarning(this, null, result.message, () => {
              if (result.behaviorType === handler.behaviorTypes.logout) {
                this.logout(this);
              } else if (result.behaviorType === handler.behaviorTypes.resetSession) {
                this.resetSession(this);
              }
            });
          } else if (result.causeType === handler.causeTypes.permissionError) {
            // ユーザー権限エラーの場合、エラーダイアログを表示しログアウトする
            alert.showError(this, null, result.message, () => {
              this.logout(this);
            });
          }
        });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * TVVロックフラグ読出し処理
     */
    async readLockFlag() {
      try {
        this.isLoading = true;

        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-lock',
          },
          // エラー発生のコールバックを実装
          (errorType) => { errorType; this.showUnexpectedErrorTerminate(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        //正常
        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              switch (response.data.user_data.result) {
                case 'ok':
                  /* eslint-disable max-depth */
                  if (this.selectedMode === 'writeWithSavedData') {
                    await this.updateTable();
                    this.modalSize = 'xl';
                    this.phase = PHASE.EXECUTE_SELECT;
                    break;
                  } else if (this.selectedMode === 'writeWithManual') {
                    this.modalSize = 'lg';
                    this.phase = PHASE.EXECUTE_SHOW;
                    break;
                  }
                  break;
                case 'ng':
                  this.phase = PHASE.REGISTERED;
                  break;
                default:
                  this.showUnexpectedErrorTerminate();
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
            default:
              this.showUnexpectedErrorTerminate();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** テーブル情報更新 */
    async updateTable() {
      try {
        this.isLoading = true;
        // バックエンドAPI GETのみ
        const response = await executeSyncRequest(
          this,
          // GET API 呼び出しのコールバック
          async () => {
            return await api.getParamCall(
              ApiService.WSP,
              '/readData/requirements/' + this.requirementId,
              {
                vin: this.vehicleInfo.vehicle.vin.vin,
                system_name: this.systemId,
                work_support_id: this.workSupportId
              }
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedErrorTerminate(); },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => { getApiResponse; return ''; },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常終了：一覧データ取得
          this.createSystemTableItems(response.data.read_data_list);
          this.$nextTick(() => {
            this.searchFilter();
          });
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** TVV書込み前通信処理 保存データ書き込み */
    async executeWrite() {
      try {
        this.isLoading = true;
        // 手動書込みの場合は保存結果のdataId、そうでない場合は選択したdataId
        this.dataId = this.dataId === '' ? this.selectedData.data_id : this.dataId;

        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write_with_session',
            requirement_id: this.requirementId,
            data_id: this.dataId
          },
          // エラー発生のコールバックを実装
          (errorType) => { errorType; this.showUnexpectedErrorTerminate(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              await this.readTvv();
              break;
            case REQUEST_STATUS_FAILED:
              switch (response.data.async_code) {
                case error.WSP_GENERAL_ERROR: // async_code: 40000000
                  this.showUnexpectedErrorTerminate();
                  break;
                case error.WSP_132_WRITE_FAILED: // async_code: 40132001
                default:
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedErrorTerminate();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** TVV書込み前通信処理 手動書込み */
    async executeManualWrite() {
      try {
        this.isLoading = true;

        const endPoint = '/readData/requirements/' + this.requirementId + '/netApps/' + this.netAppId;
        const reqBody = {
          tvv: {
            type: this.type,
            variant: this.variant,
            version: this.version
          },
          user_name: this.userName
        };

        // APIレスポンスの検証
        const response = await api.postCall(ApiService.WSP, endPoint, reqBody);
        handler.validate(handler.validateTypes.all, response, this, null, () => {
          // 処理が成功したときのコールバック処理
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              this.dataId = response.data.data_id;
              break;
            case REQUEST_STATUS_FAILED:
            default:
              this.showUnexpectedErrorTerminate();
              break;
          }
        }, (result) => {
          // 処理が失敗したときのコールバック処理
          // セッションが不正・ネットワークエラーならログアウト処理を行う
          if (result.causeType === handler.causeTypes.networkError ||
            result.causeType === handler.causeTypes.invalidSessionToken) {
            if (result.behaviorType === handler.behaviorTypes.logout) {
              this.logout(this);
            } else if (result.behaviorType === handler.behaviorTypes.resetSession) {
              this.resetSession(this);
            }
          } else if (result.causeType === handler.causeTypes.permissionError) {
            // ユーザー権限エラーの場合、ログアウトする
            this.logout(this);
          } else {
            this.showUnexpectedErrorTerminate();
          }
        });

        await this.executeWrite();
      } finally {
        this.isLoading = false;
      }
    },

    async readTvv() {
      try {
        this.isLoading = true;

        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read-tvv'
          },
          // エラー発生のコールバックを実装
          (errorType) => { errorType; this.showUnexpectedErrorTerminate(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        //正常
        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              this.phase = PHASE.STOP_CHECK;
              this.modalSize = '';
              // 表生成
              this.tvvData = response.data.user_data.readout_data;
              this.$nextTick(() => {
                this.createTvvTableItems();
              });

              break;
            case REQUEST_STATUS_FAILED:
            default:
              this.showUnexpectedErrorTerminate();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** TVVロックフラグ書込み処理 */
    async writeLockFlag() {
      try {
        this.isLoading = true;

        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write',
            requirement_id: this.requirementId,
            data_id: this.dataId
          },
          // エラー発生のコールバックを実装
          (errorType) => { errorType; this.showUnexpectedErrorTerminate(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              switch (response.data.user_data.result) {
                case 'ok':
                  this.phase = PHASE.SUCCESS;
                  break;
                case 'ng':
                default:
                  this.phase = PHASE.ERROR;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              switch (response.data.async_code) {
                case error.WSP_132_WRITE_FAILED: // async_code: 40132001
                  this.showUnexpectedError();
                  break;
                case error.WSP_GENERAL_ERROR: // async_code: 40000000
                default:
                  this.showUnexpectedErrorTerminate();
                  break;
              }
              break;
            default:
              this.showUnexpectedErrorTerminate();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * DefaultSession遷移処理
     * @param {number} phase 呼び出し元によって処理結果を分岐 0:正常終了で機能終了 1:結果に関わらず機能終了
     */
    async exit(phase) {
      try {
        this.isLoading = true;

        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバックを実装
          (errorType) => { errorType; this.showUnexpectedErrorTerminate(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (phase === 0) {
          // 0:正常終了で機能終了
          if (response) {
            switch (response.data.status) {
              case REQUEST_STATUS_COMPLETED:
                this.closeWizard();
                break;
              case REQUEST_STATUS_FAILED:
              default:
                this.showUnexpectedErrorTerminate();
                break;
            }
          }
        } else {
          // 1:結果に関わらず機能終了
          this.closeWizard();
          return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**  共通エラー画面(終了処理無し)へ遷移 */
    async showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.COMMON_ERROR;
    },

    /**  共通エラー画面(終了処理有り)へ遷移 */
    async showUnexpectedErrorTerminate() {
      // 異常終了：エラー表示
      this.phase = PHASE.TERMINATE;
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result handler.validate で返ってきたバリデーション結果
    */
    validateErrorResult(result) {
      apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },
  },

  mounted() {
    this.init();
    this.mountedLogic();
  },
};